<template>
  <div class="bg-gray-100 px-8 lg:px-20 pt-8 text-gray-600">
          <h2 class="text-2xl text-widest font-semibold">रोजगारी पसलका शाखा सम्पर्क कार्यलय </h2>
      <div class="mt-8 lg:flex lg:space-x-32 space-y-8 lg:space-y-0 text-center">
          <div>
              <h2 class="text-xl font-semibold">काठमाडौं</h2>
              <h3 class="text-lg">मिन भवन मेन रोड</h3>
              <h3 class="text-lg">शान्तिनगर गेट संगै, </h3>
              <h3 class="text-lg">काठमाडौँ, नेपाल</h3>
              <h3 class="text-lg"> ०१-४१०६५४०</h3>
          </div>
          <div>
              <h2 class="text-xl font-semibold">काठमाडौं</h2>
              <h3 class="text-lg">मिन भवन मेन रोड</h3>
              <h3 class="text-lg">शान्तिनगर गेट संगै, </h3>
              <h3 class="text-lg">काठमाडौँ, नेपाल</h3>
              <h3 class="text-lg"> ०१-४१०६५४०</h3>
          </div>
          <div>
              <h2 class="text-xl font-semibold">काठमाडौं</h2>
              <h3 class="text-lg">मिन भवन मेन रोड</h3>
              <h3 class="text-lg">शान्तिनगर गेट संगै, </h3>
              <h3 class="text-lg">काठमाडौँ, नेपाल</h3>
              <h3 class="text-lg"> ०१-४१०६५४०</h3>
          </div>
          <div>
              <h2 class="text-xl font-semibold">काठमाडौं</h2>
              <h3 class="text-lg">मिन भवन मेन रोड</h3>
              <h3 class="text-lg">शान्तिनगर गेट संगै, </h3>
              <h3 class="text-lg">काठमाडौँ, नेपाल</h3>
              <h3 class="text-lg"> ०१-४१०६५४०</h3>
          </div>
          <div>
              <h2 class="text-xl font-semibold">काठमाडौं</h2>
              <h3 class="text-lg">मिन भवन मेन रोड</h3>
              <h3 class="text-lg">शान्तिनगर गेट संगै, </h3>
              <h3 class="text-lg">काठमाडौँ, नेपाल</h3>
              <h3 class="text-lg"> ०१-४१०६५४०</h3>
          </div>
      </div>
    <div class="mt-8 text-center lg:text-left">
        <h2 class="text-2xl text-widest font-semibold">मुख्य रोजगारदाताहरू </h2>
        <div class="grid grid-cols-2 lg:grid-cols-6 pt-4 lg:pt-8 lg:px-6">
            <div class="h-28 w-28 lg:h-36 lg:w-36 filter-grayhighscale hover:filter-none cursor-pointer"><img src="../assets/img/nabil.png"></div>
            <div class="h-28 w-28 lg:h-36 lg:w-36 filter-grayhighscale hover:filter-none cursor-pointer"><img src="../assets/img/nabil.png"></div>
            <div class="h-28 w-28 lg:h-36 lg:w-36 filter-grayhighscale hover:filter-none cursor-pointer"><img src="../assets/img/nabil.png"></div>
            <div class="h-28 w-28 lg:h-36 lg:w-36 filter-grayhighscale hover:filter-none cursor-pointer"><img src="../assets/img/nabil.png"></div>
            <div class="h-28 w-28 lg:h-36 lg:w-36 filter-grayhighscale hover:filter-none cursor-pointer"><img src="../assets/img/nabil.png"></div>
            <div class="h-28 w-28 lg:h-36 lg:w-36 filter-grayhighscale hover:filter-none cursor-pointer"><img src="../assets/img/nabil.png"></div>
        </div>
    </div>
    <div class="lg:flex text-center pb-20">
        <div class="flex flex-col lg:flex-row items-center w-full lg:w-1/2">
            <img src="../assets/img/jeep.png" class="w-52 h-40">
            <div class="px-8">
                <h2 class="text-xl font-semibold mt-8 lg:mt-0">घुम्ती रोजगारी पसल </h2>
                <p class="py-4 text-gray-500">घुम्ती रोजगारी पसलको प्रमुख उद्येश्य रोजगारी पसलको शाखा कार्यालय नभएको ठाउँहरु पुगि रोजगारीमूलक तथा शिपमुलक कार्यक्रम संचालनमा ल्याउने तथा नेपालमै केहि गरौ भन्ने भावना सिर्जना र उत्प्रेरित गर्ने हो। </p>
            </div>
        </div>
        <div class="flex flex-col lg:flex-row items-center w-full lg:w-1/2">
            <img src="../assets/img/app.png" class="w-52 lg:transform lg:-translate-y-14">
            <div class="px-8">
                <h2 class="text-xl font-semibold">रोजगारी एप </h2>
                <p class="py-4 text-gray-500">बेरोजगारलाई रोजगार, रोजगारदातालाई कामदार रोजगारी पसल छ साथमा, रोजगार छ हातमा!! </p>
                <h3 class="py-4 text-gray-500">आज नै हाम्रो एप डाउनलोड गर्नुहोस् </h3>
                <p class="text-lg text-white"><button class="bg-yellow-600 hover:bg-yellow-500 transition ease-out duration-500 rounded-full px-8 py-2">Playstore</button><button class="bg-yellow-600 hover:bg-yellow-500 transition ease-out duration-500 rounded-full px-8 py-2 ml-0 lg:ml-6 mt-4">App store</button></p>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>